<p-toast></p-toast>
<div class="card">
    <h2 class="text-3xl font-bold text-900 mt-0 mb-4">Post Expenses to General Ledger</h2>
    <p class="text-600 mb-4">Select approved expenses to post their expense and Accounts Payable journal entry.</p>

    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <p-button label="Post Selected Expenses" icon="pi pi-check-square"
                [disabled]="!canPostExpense || !selectedExpenses || selectedExpenses.length === 0"
                (click)="openPostingDialog()"></p-button>
        </ng-template>
    </p-toolbar>

    <p-table #dt [value]="approvedExpenses" [(selection)]="selectedExpenses" dataKey="expenseId" [loading]="isLoading"
        [rows]="10" [paginator]="true" responsiveLayout="scroll"
        [globalFilterFields]="['description', 'submittedBy.name', 'partyDisplayName', 'vendor.name']" [lazy]="true"
        (onLazyLoad)="loadExpensesLazy($event)" [totalRecords]="totalRecords">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                <th pSortableColumn="expenseNumber">Expense# <p-sortIcon field="expenseNumber"></p-sortIcon></th>
                <th pSortableColumn="submissionDate">Date <p-sortIcon field="submissionDate"></p-sortIcon></th>
                <th pSortableColumn="submittedBy.name">Submitted by <p-sortIcon field="submittedBy.name"></p-sortIcon></th>
                <th pSortableColumn="description">Description <p-sortIcon field="description"></p-sortIcon></th>
                <th>Party</th>
                <th pSortableColumn="totalAmount" class="text-right">Amount <p-sortIcon
                        field="totalAmount"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-expense>
            <tr>
                <td><p-tableCheckbox [value]="expense"></p-tableCheckbox></td>
                <td>{{ expense.expenseNumber }}</td>
                <td>{{ expense.submissionDate | date:'shortDate' }}</td>
                <td>{{ expense.submittedBy?.name }}</td>
                <td>{{ expense.description }}</td>
                <td>{{ expense.crmDisplayName || expense.partyDisplayName || expense.vendor?.name || 'N/A' }}</td>
                <td class="text-right">{{ expense.totalAmount | currency:expense.currencyCode:'symbol':'1.2-2' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center">No approved expenses are pending to be posted.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Posting Dialog -->
<p-dialog header="Create Voucher and Post to Journal" [(visible)]="displayPostingDialog" [modal]="true"
    [style]="{width: '50vw'}">
    @if (displayPostingDialog) {
    <form [formGroup]="postingForm" class="mt-3">
        <!-- Summary Section -->
        <div class="surface-100 p-3 border-round mb-4 text-center">
            <div class="text-sm text-600">
                Posting for {{ selectedExpenses.length }} selected expense(s).
            </div>
            <div class="text-xl font-bold">
                Total Amount to Post:
                {{ totalToPost | currency: 'USD' : 'symbol' : '1.2-2' }}
            </div>
        </div>

        <!-- Form container with surface background -->
        <div class="surface-ground p-4 border-round">
            <h3 class="mt-0 mb-4 text-xl font-semibold">Journal Details</h3>
            <div class="p-fluid grid">
                <!-- Voucher Date -->
                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-calendar"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-datePicker id="voucherDate" formControlName="voucherDate" [showIcon]="false"
                                styleClass="w-full"></p-datePicker>
                            <label for="voucherDate">Voucher Date</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <!-- Debit Account -->
                <div class="field col-12">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-arrow-down-circle"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select id="debitAccount" formControlName="debitAccountId" [options]="expenseAccounts"
                                optionLabel="accountName" optionValue="accountId" styleClass="w-full"></p-select>
                            <label for="debitAccount">Debit Account (Expense Type)</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <!-- Credit Account -->
                <div class="field col-12">
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-arrow-up-circle"></i>
                        </p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select id="creditAccount" formControlName="creditAccountId" [options]="liabilityAccounts"
                                optionLabel="accountName" optionValue="accountId" styleClass="w-full"></p-select>
                            <label for="creditAccount">Credit Account Override</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                    <small>Leave blank to use each expense's header credit account.</small>
                </div>

                <!-- Notes -->
                <div class="field col-12">
                    <p-iftaLabel>
                        <textarea id="notes" pInputTextarea formControlName="notes" rows="3" class="w-full"></textarea>
                        <label for="notes">Notes</label>
                    </p-iftaLabel>
                </div>
            </div>
        </div>
    </form>
    }
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text"
            (click)="displayPostingDialog = false"></p-button>
        <p-button label="Confirm & Post" icon="pi pi-check" (click)="postVoucherAndJournalEntry()"
            [disabled]="!canConfirmPosting()"></p-button>
    </ng-template>
</p-dialog>
